import { useEffect, useRef } from 'react';
export const useVisibilitySensor = ({ onChange, containment, active = true, threshold = 0, ref, notifyVisibleOnce = false, }) => {
    const state = useRef({ visibleNotified: false });
    useEffect(() => {
        if (!active || !ref.current) {
            return () => { };
        }
        const options = {
            root: containment || null,
            threshold,
        };
        const observer = new window.IntersectionObserver((entries) => {
            const entry = entries[0];
            const isVisible = entry.isIntersecting;
            if (notifyVisibleOnce && isVisible && !state.current.visibleNotified) {
                onChange(true);
                state.current.visibleNotified = true;
            }
            else if (!notifyVisibleOnce) {
                onChange(isVisible);
            }
        }, options);
        observer.observe(ref.current);
        return () => {
            observer.disconnect();
        };
    }, [active, containment, notifyVisibleOnce, onChange, ref, threshold]);
};
